export const DISPLAY_CATEGORY_TITLE = 'Afficher cette categorie';
export const EDIT_CATEGORY_TITLE = 'Editer cette categorie';
